<div class="p-modal-login">
  <div class="p-modal-login__title">
    <h2 class="c-text-l" [innerHTML]="'heading.passwordInput' | staticMsg"></h2>
  </div>
  <div class="p-modal-login__item">
    <div class="c-form-element-confirm">
      <div class="c-form-element-confirm__label">
        <span class="c-form-element-confirm__label-text" [innerHTML]="'label.amcAccountNumber' | staticMsg"></span>
      </div>
      <div class="c-form-element-confirm__status">
        <span class="c-form-element-confirm__status-text">{{ amcNumber }}</span>
      </div>
    </div>
  </div>
  <div class="p-modal-login__item">
    <asw-input
      id="PasswordInputPasswordInput"
      label="{{ 'label.password' | staticMsg }}"
      type="password"
      autocomplete="current-password"
      aria-invalid="false"
      placeholder="{{ 'placeholder.password' | staticMsg }}"
      [formControl]="passwordFormControl"
    ></asw-input>
    <div class="p-modal-login__item-link c-text-link-arrow01" [innerHtml]="'message.forgetPassword' | staticMsg"></div>
    <div class="p-modal-login__btn">
      <asw-button
        id="password-input-login-button"
        label="{{ 'label.login' | staticMsg }}"
        (click$)="clickLogin()"
      ></asw-button>
    </div>
  </div>
</div>
